module.exports = "pegasus_template/assets/themecapture1/launch/202.png";